import { render } from "./Days.vue?vue&type=template&id=54f7b2de&scoped=true"
import script from "./Days.vue?vue&type=script&lang=js"
export * from "./Days.vue?vue&type=script&lang=js"

import "./Days.vue?vue&type=style&index=0&id=54f7b2de&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f7b2de"]])

export default __exports__